<template>
  <div class="invitation-success-container">
    <w-navbar
        :icon="'iconchevron-left'"
        nav_title="超级简历"
        @mobileLeftBtn="leftBtnClick"
        v-show="iosOrAndroidShow"
    />

    <div class="main-container">
      <div class="text-container content">
        <span class="iconfont iconwancheng"></span>
        <div class="tips">
          <span>恭喜你</span>
        </div>
        <div class="university">
          <span>已通过申请，关注公众号</span><br>
          <span>立即使用{{groupName}}专属超级简历！</span>
        </div>
      </div>
      <div class="qrcode-container content">
        <div class="wondercv">
          <img src="https://files.wondercv.com/m/invitation/group_invitation_success.png" alt="">
          <div class="desc">
            <div class="title">超级简历WonderCV</div>
            <div class="contents">关注微信公众号</div>
          </div>
        </div>
        <div class="code">
          <img :src="qrcodeUrl" alt="" v-show="qrcodeUrl">
        </div>
        <div class="sub-desc">长按扫码关注 立即升级简历</div>
      </div>
      <div class="explain">
        <p>超级简历使用说明</p>
        <p>1. 领取成功后需关注 「 超级简历WonderCV 」公众号，在手机或电脑上均可登录使用</p>
        <p>2. 通过本次机构专属活动邀请，可免费享受所有超级简历会员功能，直到活动结束会员自动过期</p>
        <p>3. 其他使用问题，可直接在超级简历后台留言</p>
      </div>
    </div>
  </div>
</template>

<script>
  import WNavbar from '@/components/global/w-navbar'
  import { componentsMixin } from '@/assets/js/mixin/components'
  import { envMixin, eventMixin } from '../../../assets/js/mixin/global'
  import { userMixin } from "../../../assets/js/mixin/user";
  import Cookies from 'js-cookie'


  export default {
    name: "group_invitation_success",
    mixins: [ componentsMixin, eventMixin, envMixin, userMixin ],
    components: {
      WNavbar
    },
    data() {
      return {
        groupName:'',
        qrcodeUrl:''
      }
    },
    async mounted() {
      this.groupName = this.$route.query.groupName;
      let data = {
        scene_str: 'bind_'+ this.cvAccountToken,
        account_type: 'cv_account',
        operation_type :'bind',
        expire_seconds: 180
      }
      let res = await this.$api.auth.getQrCodeUrl(data)
      if (res.code === 1000) {
        this.qrcodeUrl = res.data.url
      }else {
        this.showToast(res.message)
      }
    },
    methods: {
      leftBtnClick() {
        this.$router.back()
      }
    }

  }
</script>

<style lang="scss">
  @media only screen and (min-width: 1024px) {
    body{
      width: 375px;
      margin: 0 auto!important;
    }
    html{
      font-size: 110px!important;
    }
  }
</style>

<style lang="scss" scoped>
  .invitation-success-container{
    width: 375px;
    height: auto;
    .main-container{
      padding-top: 44px;
      height: auto;
      box-sizing: border-box;
      background-color: #f5f5f5;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .content{
        margin-top: 12px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0px 2px 8px 0px rgba(222, 222, 222, 0.5);
      }
      .text-container{
        width: 346px;
        height: 215px;
        text-align: center;
        box-sizing: border-box;
        /*padding-top: 31px;*/
        padding: 31px 35px 0;
        .iconfont{
          /*margin-top: 31px;*/
          font-size: 54px;
          color: #ff4f4c;
          /*margin: 31px auto;*/
        }
        .tips{
          width: 100%;
          height: 20px;
          display: flex;
          margin-top: 28px;
          justify-content: space-between;
          align-items: center;
          span{
            color: #404040;
            font-size: 20px;
          }
          &:after{
            content: '';
            width: 70px;
            border-top: 2px solid #cfcfcf;
          }
          &:before{
            content: '';
            width: 70px;
            border-top: 2px solid #cfcfcf;
          }
        }
        .university{
          width: 100%;
          color: #404040;
          margin-top: 12px;
          font-size: 15px;
          line-height: 24px;
        }
      }
      .qrcode-container{
        width: 346px;
        height: 347px;
        box-sizing: border-box;
        padding: 26px 25px;
        .wondercv{
          width: 100%;
          display: flex;
          img{
            width: 44px;
            height: 44px;
          }
          .desc{
            color: #1e1e1e;
            margin-left: 13px;
            .title{
              font-size: 15px;
              line-height: 21px;
              font-weight: bold;
            }
            .contents{
              color: #606060;
              font-size: 13px;
              line-height: 18px;
            }
          }
        }
        .code{
          width: 215px;
          height: 215px;
          /*background-color: #eee;*/
          margin: 13px auto;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .sub-desc{
          width: 100%;
          text-align: center;
          color: #909090;
          font-size: 14px;
          line-height: 21px;
        }
      }
      .explain{
        width: 346px;
        height: auto;
        margin: 18px auto;
        font-size: 14px;
        color: #9c9c9c;
        line-height: 21px;
      }
    }
  }
</style>